export default __webpack_public_path__ + "static/media/discordicon.76609922.svg";